import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { CachedDataService } from '@services/data/cached-data.service';
@Injectable()
export class SignUpGuard implements CanActivate {

  constructor(
    private router: Router,
    private cachedDataService: CachedDataService) {
  }

  public canActivate() {
    if (this.cachedDataService.isAuth()) {
      if (this.cachedDataService.getCurrentUser() && !this.cachedDataService.getCurrentUser().phoneNumberConfirmed) {
        return true;
      } else {
        this.router.navigate(['/personal', this.cachedDataService.getCurrentUser().id]);
        return false;
      }
    } else {
      return true;
    }
  }
}






// WEBPACK FOOTER //
// ./src/app/guards/signUp.guard.ts